import { ImageProps } from 'next/image'
import { FC } from 'react'

import { TextLinkProps } from '../A'

import * as SC from './styled'

export type PushPWAFunctionnalitySectionProps = {
  className?: string
  image: ImageProps
  text: string
  cta: TextLinkProps
  onClose?: () => void
}

const PushPWAFunctionnalitySection: FC<PushPWAFunctionnalitySectionProps> = (
  props
) => {
  const { className, image, text, cta, onClose } = props

  return (
    <SC.Container className={className}>
      <SC.ImageWrapper>
        <SC.StyledImage {...image} />
      </SC.ImageWrapper>
      <SC.Text>{text}</SC.Text>
      <SC.CTA {...cta}>{cta?.text}</SC.CTA>
      <SC.CloseButtonWrapper onClick={onClose}>
        <SC.CloseButton icon="close" />
      </SC.CloseButtonWrapper>
    </SC.Container>
  )
}

export default PushPWAFunctionnalitySection
